module.exports = __webpack_public_path__ + "static/media/dummy_sml.9a15bef0.mp4";